export default "__VITE_ASSET__cf7adda9__"